export const PRIMARY_COLOR = '#3c599f'
export const MAIN_COLOR = "#6eb4fc"

// admin
export const BLUE_LIGHT_COLOR = '#1089FF'
export const BLUE_DARK_COLOR = '#004BA0'

export const GRAY_BACKGROUND = '#F4F6F8'